export const ParserDateTime = (unixTimestamp) => {
    // Get current datetime in milliseconds
    const now = new Date().getTime();

    // Convert Unix timestamp to milliseconds
    const unixTimestampMs = (unixTimestamp < 1000000000000) ? unixTimestamp * 1000 : unixTimestamp;

    var realDate = new Date(Number(unixTimestampMs));
        realDate = realDate?.toLocaleString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    })


    // Calculate the difference in milliseconds
    const differenceMs = now - unixTimestampMs;

    // Convert milliseconds to seconds, minutes, hours, days, months, and years
    const seconds = Math.floor(differenceMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30.4375); // Average number of days in a month
    const years = Math.floor(months / 12);

    // Calculate remaining hours, minutes, seconds, days, and months
    const remainingHours = hours % 24;
    const remainingMinutes = minutes % 60;
    const remainingSeconds = seconds % 60;
    const remainingDays = days % 30.4375;
    const remainingMonths = months % 12;

    if (years > 1) {
        return `${realDate} Uhr`;
    } else if (years === 1) {
        return `${realDate} Uhr`;
    } else if (remainingMonths > 1) {
        return `${realDate} Uhr`;
    } else if (remainingMonths === 1) {
        return `${realDate} Uhr`;
    } else if (remainingDays > 1) {
        return `vor ${remainingDays} Tagen`;
    } else if (remainingDays === 1) {
        return `vor ${remainingDays} Tag`;
    } else if (remainingHours > 1) {
        return `vor ${remainingHours} Stunden`;
    } else if (remainingHours === 1) {
        return `vor ${remainingHours} Stunde`;
    } else if (remainingMinutes > 1) {
        return `vor ${remainingMinutes} Minuten`;
    } else if (remainingMinutes === 1) {
        return `vor ${remainingMinutes} Minute`;
    } else if (remainingSeconds >= 0) {
        return "Jetzt";
    }
}

export const ParserGermanDateTime = (text) => {

    if(typeof text === "undefined" || text === "-") {return;}

    text = new Date(Number(text));
    text = text?.toLocaleString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    })


    return text+" Uhr";
}

export const ParserGermanDate = (text) => {

    if(typeof text === "undefined" || text === "-") {return;}

    text = new Date(Number(text));
    text = text?.toLocaleString("de-DE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    })


    return text;
}
